import { Component } from 'react';
import './Servicio.scss';
import type { ReactElement } from 'react';
import type { ServicioData } from '../data/CardData';

export type { ServicioData };

export interface ServicioProps {
    data: ServicioData;
}

class Servicio extends Component<ServicioProps> {

    render() {
        let content: ReactElement | undefined;
        if (this.props.data.name && this.props.data.name !== '') {
            content = <span dangerouslySetInnerHTML={{ __html: this.props.data.icon_html ?? '' }} title={this.props.data.name}></span>;
        }
        return (
            <div className='servicio'>
                {content}
            </div>
        );
    }
}

export default Servicio;
